export default __webpack_public_path__ + "static/media/easy-installation.3ca098ba.svg";